<template>
  <div class="indexbox">
    <el-form ref="form" :model="form" :rules="rules" class="formbox">
      <div class="imgbox">
        <img src="../../assets/img/logo.png" alt="" />
        <p>{{ $t("lg.登录") }}OMS</p>
      </div>
      <el-form-item prop="email">
        <span class="form_tit">{{ $t("lg.邮件地址") }}*</span>
        <el-input v-model="form.email" clearable></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <span class="form_tit">{{ $t("lg.密码") }}*</span>
        <el-input v-model="form.password" type="password" maxlength="18" clearable show-password></el-input>
      </el-form-item>
      <div class="password">
        <p @click="show = true">{{ $t("lg.忘记密码") }}</p>
      </div>
      <el-form-item>
        <el-button type="primary" @click.native.prevent="onSubmit" :loading="loading">{{ $t("lg.登录") }}</el-button>
      </el-form-item>
      <div class="registerbox">
        <p>
          {{ $t("lg.无账号") }}
          <router-link to="register">{{ $t("lg.创建新的") }}</router-link>
        </p>
      </div>
    </el-form>
    <el-dialog :title="$t('lg.忘记密码')" :visible.sync="show" width="30%">
      <el-form ref="sendform" :model="sendform" :rules="sendrules" class="formbox">
        <el-form-item prop="email">
          <span class="form_tit">{{ $t("lg.邮件地址") }}*</span>
          <el-input v-model="sendform.email" clearable></el-input>
        </el-form-item>
        <el-form-item class="btnbox">
          <el-button type="primary" @click.native.prevent="sendPasswordEmail" :loading="loadinga">{{ $t("lg.发送") }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import { setToken } from "@/utils/auth";
  export default {
    data() {
      return {
        form: {
          email: "",
          password: "",
        },
        loading: false,
        rules: {
          email: [
            {
              required: true,
              trigger: "blur",
              message: this.$t("lg.请输入邮件地址"),
            },
          ],
          password: [
            {
              required: true,
              trigger: "blur",
              message: this.$t("lg.请输密码"),
            },
          ],
        },
        show: false,
        sendform: {
          email: "",
        },
        sendrules: {
          email: [
            {
              required: true,
              trigger: "blur",
              message: this.$t("lg.请输入邮件地址"),
            },
          ],
        },
        loadinga: false,
      };
    },
    computed: {},
    watch: {},
    methods: {
      onSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$post({
              url: "/app/auth/login",
              data: this.form,
              success: (res) => {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                setToken(res.data.token);
                // sessionStorage.setItem("activeIndex", "/");
                this.$store.dispatch("remove_API_ID");
                setTimeout(() => {
                  this.$router.replace("/");
                  this.loading = false;
                }, 1500);
              },
              tip: () => {
                setTimeout(() => {
                  this.loading = false;
                }, 1500);
              },
            });
          }
        });
      },
      sendPasswordEmail() {
        this.$refs.sendform.validate((valid) => {
          if (valid) {
            this.loadinga = true;
            this.$post({
              url: "/app/auth/sendPasswordEmail",
              data: this.sendform,
              success: () => {
                this.$message({
                  message: "发送成功",
                  type: "success",
                });
                setTimeout(() => {
                  this.show = false;
                  this.loadinga = false;
                }, 1500);
              },
              tip: () => {
                setTimeout(() => {
                  this.loadinga = false;
                }, 1500);
              },
            });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .indexbox {
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 30px;
    .formbox {
      width: 480px;
      padding: 10px;
      max-width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .imgbox {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 147px;
          height: 53px;
        }
        p {
          width: 100%;
          text-align: center;
          color: #3b3b3b;
          font-size: 40px;
          font-weight: 600;
          font-family: PingFang SC;
          padding: 40px 0;
        }
      }
      .password {
        width: 100%;
        p {
          color: $color;
          font-size: 16px;
          cursor: pointer;
        }
        margin-bottom: 40px;
      }
      /deep/.el-form-item {
        width: 100%;
        margin-bottom: 30px !important;
        .el-input {
          .el-input__inner {
            height: 50px;
          }
        }
        .el-form-item__content {
          width: 100%;
          .el-button {
            width: 100%;
            height: 48px;
            background: $color !important;
            border-radius: 5px;
            border-color: $color;
            font-size: 16px;
            font-weight: 600;
          }
        }
      }
      .registerbox {
        width: 100%;
        text-align: center;
        color: #3b3b3b;
        font-size: 16px;
        padding-top: 10px;
        a {
          color: $color;
          font-size: 16px;
        }
      }
    }
  }
</style>
